import { routerInitialized } from '@perpay-web/fintech/actions/router';
import store from '@perpay-web/fintech/settings/configureStore';
import { analyticsLocationChange } from '@perpay-web/hooks/useTrackLocationChange';
import { getOrCreateRouter } from '@perpay-web/services/router';
import {
    clearLastReactStorefrontPage,
    pathIsInReactStorefront,
    setLastReactStorefrontPage,
    setReactStorefrontHistory,
} from '@perpay-web/utils/routeUtils';

import { appRoutes } from './AppRoutes';

const onInitialize = (router) => {
    store.dispatch(routerInitialized());

    // On initialization, dispatch location change once
    store.dispatch(
        analyticsLocationChange({
            location: router.state.location,
            action: 'POP',
        }),
    );
    clearLastReactStorefrontPage();
    if (pathIsInReactStorefront(router.state.location.pathname)) {
        setLastReactStorefrontPage(router.state.location);
    }
    setReactStorefrontHistory(router.state);
};

const createRouter = () => getOrCreateRouter(appRoutes, onInitialize);

export default createRouter();
